import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useRouter } from "next/navigation";
import CflowApi from "@/api/Cflow";
import { toKeyValue } from "@/utils/convert";

const Step10 = ({ data }) => {
    const router = useRouter();
    const [isLoading, setIsLoading] = useState(true);
    const [numTramite, setNumTramite] = useState("");
    const hasRun = useRef(false);

    const prepareTramite = async (data) => {
        setIsLoading(true);
        try {
            const { data: res } = await CflowApi.post(data);
            if (res.data) {
                const resData = toKeyValue(res.data)
                setNumTramite(resData.CODIGO)
                return true;
            } else {
                return false;
            }

        } catch (error) {
            console.error("Error al preparar el trámite:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleVolverInicio = () => {
        router.push("/");
    };

    useEffect(() => {
        if (!hasRun.current && data) {
            hasRun.current = true;
            prepareTramite(data);
        }
    }, [data]);

    return (
        <>
            {isLoading ? (
                <div className="flex h-80 w-full items-center justify-center gap-4">
                    <div className="loading"></div> Enviando Tramite ...
                </div>
            ) :
                (!isLoading && numTramite ? (
                    <div className="flex min-h-[60vh] flex-col items-center justify-center rounded-xl bg-white p-4 shadow-md">
                        <h2 className="mb-4 text-2xl font-semibold text-green-700">
                            ¡Trámite realizado con éxito!
                        </h2>

                        <div className="mb-6 text-lg text-gray-800">
                            Tu número de trámite es:{" "}
                            <span className="font-bold">{numTramite}</span>
                        </div>

                        <div className="mb-6 text-lg text-gray-800">
                            Para dar seguimiento a tu trámite, utiliza el siguiente enlace:&nbsp;
                            <a
                                href={`https://online.portoviejo.gob.ec/Tramites/SeguimientoTramites.aspx?codtramite=${numTramite}`}
                                className="font-semibold text-blue-600 hover:text-blue-800 underline"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Seguimiento del trámite
                            </a>
                        </div>
                    </div>
                ) : (
                    <div className="flex min-h-[60vh] flex-col items-center justify-center rounded-xl bg-white p-4 shadow-md">
                        <h2 className="mb-4 text-2xl font-semibold text-red-700">
                            Error al realizar el trámite
                        </h2>
                        <p className="mb-6 text-lg text-gray-800">
                            Ocurrió un error al intentar realizar el trámite. Por favor,
                            inténtalo de nuevo.
                        </p>
                        <button
                            onClick={handleVolverInicio}
                            className="rounded-lg bg-primary px-6 py-2 text-white"
                        >
                            Volver al inicio
                        </button>
                    </div>
                ))}
        </>
    );
};

export default Step10;

Step10.propTypes = {
    data: PropTypes.object.isRequired,
};
